import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_GPT_RECOMMENDATION_PENDING,
  GET_GPT_RECOMMENDATION,
  SG_GET_GPT_RECOMMENDATION,
  DELETE_GPT_RECOMMENDATION,
  SG_DELETE_GPT_RECOMMENDATION,
  FETCH_GPT_RECOMMENDATION,
  SG_FETCH_GPT_RECOMMENDATION,
  EDIT_GPT_RECOMMENDATION,
  SG_EDIT_GPT_RECOMMENDATION,
  ADD_GPT_RECOMMENDATION,
  SG_ADD_GPT_RECOMMENDATION,
  ALL_ERRORS,
} from "constants/actions";

function* loadmethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_GPT_RECOMMENDATION, action.payload);
    // console.log(json.data)
    yield put({ type: GET_GPT_RECOMMENDATION, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_GPT_RECOMMENDATION, loadmethods);
}


function* fetchmethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_PENDING });
  try {
    const json = yield call(api.FETCH_GPT_RECOMMENDATION, action.payload);
    yield put({ type: FETCH_GPT_RECOMMENDATION, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_GPT_RECOMMENDATION, fetchmethods);
}



function* updatemethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_PENDING });
  try {
    const json = yield call(api.EDIT_GPT_RECOMMENDATION, action.payload);
    yield put({ type: EDIT_GPT_RECOMMENDATION, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_EDIT_GPT_RECOMMENDATION, updatemethods);
}

function* addmethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_PENDING });
  try {
    const json = yield call(api.ADD_GPT_RECOMMENDATION, action.payload);
    yield put({ type: ADD_GPT_RECOMMENDATION, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_GPT_RECOMMENDATION, addmethods);
}

function* deletemethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_PENDING });
  try {
    yield call(api.DELETE_GPT_RECOMMENDATION, action.payload);
    yield put({ type: DELETE_GPT_RECOMMENDATION, payload: action.payload });

  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_GPT_RECOMMENDATION, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
